import { TGameData, TParticipant } from './types';

import {
  adventCalendarId,
  ajinomotoWheelId,
  bmiValentinesDayWheelId,
  classicWheelId,
  estivalWheelId,
  fortuneWheelId,
  grippleWheelId,
  losteWheelId,
  sirhaWheelId,
  stickAndPlayWheelId,
} from './components/games';

import ajinomotoLogo from './assets/ajinomotoLogo.png';
import bmiValentinesDayLogo from './assets/bmiValentinesDayLogo.png';
import grippleLogo from './assets/grippleLogo.png';
import logoEmxemple from './assets/logo-exemple.png';
import losteLogo from './assets/losteLogo.png';
import stickAndPlayLogo from './assets/stickAndPlayLogo.png';

export const classicWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: classicWheelId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'es',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'de',
    },
  },
};

export const estivalWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: estivalWheelId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'en',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'en',
    },
  },
};

export const fortuneWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: fortuneWheelId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'nl',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'nl',
    },
  },
};

export const adventCalendarMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: adventCalendarId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
    },
  },
};

export const adventCalendarRawMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: adventCalendarId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
    },
  },
};

export const sirhaWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: sirhaWheelId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'en',
      participationPolicy: 'once',
      winningText: '<div><strong>🎉 Congratulations!</strong><br/>Test Winning Text</div>',
      alreadyPlayedText: '<div>Test Already Played Text</div>',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: false,
    },
  },
};

export const sirhaWheelAlreadyPlayedMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Test Game',
      description:
        'Tentez de remporter votre accès au Village Partenaire et à la zone VIP concours, en tournant notre roue de la chance.',
      startDate: '2024-10-10',
      endDate: '2042-11-14',
      logo: logoEmxemple,
      animationType: sirhaWheelId,
      client: 'Test Client',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'nl',
      participationPolicy: 'per-game',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'en',
    },
  },
};

export const stickAndWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'tab title',
      description:
        'Bienvenue sur votre grand jeu ! Après avoir chargé votre photo, tentez de remporter un des nombreux lots mis en jeu.',
      startDate: '2025-02-19',
      endDate: '2025-03-31',
      logo: stickAndPlayLogo,
      animationType: stickAndPlayWheelId,
      client: 'client name footer',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program footer',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
    },
  },
};

export const grippleWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'tab title',
      description:
        'Bienvenue sur votre grand jeu ! Après avoir chargé votre photo, tentez de remporter un des nombreux lots mis en jeu.',
      startDate: '2025-02-19',
      endDate: '2025-04-19',
      logo: grippleLogo,
      animationType: grippleWheelId,
      client: 'client name footer',
      sourceProgramUrl: 'https://www.google.com',
      sourceProgramName: 'Test Source Program footer',
      gameRule: 'Test Game Rule',
      enabled: true,
      language: 'en',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'nl',
    },
  },
};

export const ajinomotoWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Mock title ajinomoto',
      description: 'Mock description ajinomoto',
      startDate: '2026-01-01',
      endDate: '2026-04-19',
      logo: ajinomotoLogo,
      animationType: ajinomotoWheelId,
      client: '',
      sourceProgramUrl: '',
      sourceProgramName: '',
      gameRule: '',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'fr',
    },
  },
};

export const bmiValentinesDayWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Mock title bmi valentines day',
      description: 'Mock description bmi valentines day',
      startDate: '2026-01-01',
      endDate: '2026-04-19',
      logo: bmiValentinesDayLogo,
      animationType: bmiValentinesDayWheelId,
      client: '',
      sourceProgramUrl: '',
      sourceProgramName: '',
      gameRule: '',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'fr',
    },
  },
};

export const LosteWheelMockGameData: {
  data: {
    game: TGameData;
    participant: TParticipant;
  };
} = {
  data: {
    game: {
      id: '1',
      title: 'Mock title loste day',
      description: 'Mock description loste day',
      startDate: '2026-01-01',
      endDate: '2026-04-19',
      logo: losteLogo,
      animationType: losteWheelId,
      client: '',
      sourceProgramUrl: '',
      sourceProgramName: '',
      gameRule: '',
      enabled: true,
      language: 'fr',
      participationPolicy: 'once',
    },
    participant: {
      firstname: 'John',
      lastname: 'Doe',
      email: 'john.doe@example.com',
      canPlay: true,
      language: 'fr',
    },
  },
};
